import { withAppCrashIfException } from 'epic';
import { bookLiveTradeEpic } from 'epic/secondaryMarket/live/bookLiveTradeEpic';
import { subscribeLiveStreamingEpic, unsubscribeLiveStreamingEpic } from 'epic/secondaryMarket/live/liveRealtimeEpic';
import { combineEpics } from 'redux-observable';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';

import { amendLiveTradeEpic } from './amendLiveTradeEpic';
import { cancelLiveTradeEpic } from './cancelLiveTradeEpic';
import { fetchKycStatusEpic } from './fetchKycStatusEpic';
import { fetchLiveInteractionClientEpic } from './fetchLiveInteractionCientEpic';
import { fetchLiveInteractionCustodianEpic } from './fetchLiveInteractionCustodianEpic';
import { fetchLiveSettlementDateEpic } from './fetchLiveSettlementDateEpic';
import { initLiveFormEpic } from './initLiveFormEpic';
import { liveQuoteCancelRequestEpic } from './liveQuoteCancelRequestEpic';
import { liveQuoteRequestEpic } from './liveQuoteRequestEpic';
import { liveTradeRequestEpic } from './liveTradeRequestEpic';
import { reloadLiveTabContentEpic } from './reloadLiveFormEpic';

export const secondaryMarketLiveQuote = () =>
  combineEpics(
    withAppCrashIfException('cancelLiveTradeEpic', cancelLiveTradeEpic()),
    withAppCrashIfException('bookLiveTradeEpic', bookLiveTradeEpic()),
    withAppCrashIfException('fetchLiveInteractionClientEpic', fetchLiveInteractionClientEpic()),
    withAppCrashIfException('fetchLiveInteractionCustodianEpic', fetchLiveInteractionCustodianEpic()),
    withAppCrashIfException('fetchLiveSettlementDateEpic', fetchLiveSettlementDateEpic()),
    withAppCrashIfException('initLiveFormEpic', initLiveFormEpic()),
    withAppCrashIfException('liveQuoteRequestEpic', liveQuoteRequestEpic()),
    withAppCrashIfException('liveTradeRequestEpic', liveTradeRequestEpic()),
    withAppCrashIfException('reloadLiveTabContentEpic', reloadLiveTabContentEpic()),
    withAppCrashIfException('amendLiveTradeEpic', amendLiveTradeEpic()),
    withAppCrashIfException('fetchKycStatusEpic', fetchKycStatusEpic()),
    withAppCrashIfException('subscribeLiveStreamingEpic', subscribeLiveStreamingEpic()),
    withAppCrashIfException(
      'unsubscribeLiveStreamingEpic',
      unsubscribeLiveStreamingEpic(limitOrderSelectors.getKeepAliveProductIds, liveSelectors.getKeepAliveProductIds),
    ),
    withAppCrashIfException('liveQuoteCancelRequestEpic', liveQuoteCancelRequestEpic()),
  );
